var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEffectiveness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165.27 165.27"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.63,
    cy: 82.63,
    r: 82.63,
    fill: "#fcde09"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.37 97.57s-2.29-48.79 15.77-48.79 6.19 89.84 25.06 89.54c17.46-.28 5.41-115.5 29.85-113.75s-3.94 105.3 27.31 103.9c16.09-.72 23.59-30.4 21.12-40.26",
    fill: "none",
    stroke: "#9c9e9f",
    strokeMiterlimit: 10,
    strokeWidth: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#249cd3",
    stroke: "#1d1d1b",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M155.08 88.48l-29.66-16.16v8.06H11.21v16.21h114.21v8.06l29.66-16.17z"
  })));
}

export default SvgEffectiveness;